import { Flex, Link, Table, Text } from '@radix-ui/themes'
import { Link as RouterLink } from '@tanstack/react-router'
import { Ops } from '@willie/schemas'
import { ASSEMBLY_PROFILES_BY_SKU, SKUS } from '../assembly'
import { MissingArticleCode } from './SkuLinesTable'
import { TabHeader } from './TabHeader'

export const SkuCatalogTab = () => (
  <Flex direction="column" gap="3">
    <TabHeader>
      The supplier order names each part by its article code. A part with no code goes out under its SKU name.
    </TabHeader>
    <Table.Root variant="surface">
      <Table.Header>
        <Table.Row>
          <Table.ColumnHeaderCell>SKU</Table.ColumnHeaderCell>
          <Table.ColumnHeaderCell>Client label</Table.ColumnHeaderCell>
          <Table.ColumnHeaderCell>Article code</Table.ColumnHeaderCell>
          <Table.ColumnHeaderCell>Used in</Table.ColumnHeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {SKUS.map((sku) => {
          const { clientLabel, articleCode } = Ops.InstallationProfileSkus.SKU_CATALOG[sku]
          return (
            <Table.Row key={sku}>
              <Table.Cell>
                <Text size="2" weight="medium">
                  {sku}
                </Text>
              </Table.Cell>
              <Table.Cell>
                <Text size="2" color="gray">
                  {clientLabel}
                </Text>
              </Table.Cell>
              <Table.Cell>
                {articleCode ? (
                  <Text size="2" className="font-mono">
                    {articleCode}
                  </Text>
                ) : (
                  <MissingArticleCode />
                )}
              </Table.Cell>
              <Table.Cell>
                <Flex gap="2" wrap="wrap">
                  {ASSEMBLY_PROFILES_BY_SKU[sku].map((assemblyProfile) => (
                    <Link key={assemblyProfile} asChild size="1" className="font-mono">
                      <RouterLink to="/installation-profiles" search={{ assembly: assemblyProfile }}>
                        {assemblyProfile}
                      </RouterLink>
                    </Link>
                  ))}
                </Flex>
              </Table.Cell>
            </Table.Row>
          )
        })}
      </Table.Body>
    </Table.Root>
  </Flex>
)
